import { render, staticRenderFns } from "./BenefitPpp3FormFields.vue?vue&type=template&id=40064112"
import script from "./BenefitPpp3FormFields.vue?vue&type=script&lang=js"
export * from "./BenefitPpp3FormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports